import { useEffect, useState } from "react";
import { FeatureType } from "../type";
import { Button, Modal, Popconfirm } from "antd";
import EditFeatureModal from "./editFeatureModal";
import deleteFeature from "../function/deleteFeature";
import { toast } from "react-toastify";

interface FeatureItemsProps {
    feature: FeatureType;
    setTriggerReload: React.Dispatch<React.SetStateAction<number>>;
}

const FeatureItems = ({ feature, setTriggerReload }: FeatureItemsProps) => {
    const [editModal, setEditModal] = useState(false);
    const [featureData, setFeatureData] = useState<FeatureType>(feature);

    useEffect(() => { setFeatureData(feature); }, [feature]);

    const handleDelete = () => {
        deleteFeature(feature.id);
        setTriggerReload(prev => prev + 1);
        toast.success("Feature deleted successfully");
    };

    return (
        <div className="bg-bg-card border border-border rounded-xl p-4 flex flex-col gap-3 shadow-card">
            <div className="flex items-start justify-between gap-4">
                <div className="flex flex-col gap-0.5 min-w-0">
                    <h3 className="text-sm font-semibold text-text-primary truncate">{featureData.name}</h3>
                    <p className="text-sm text-text-secondary">{featureData.description}</p>
                    <div className="flex flex-col gap-0.5 mt-1">
                        {featureData.key && (
                            <span className="text-xs text-text-muted">Key: {featureData.key}</span>
                        )}
                        {featureData.number != null && (
                            <span className="text-xs text-text-muted">Value: {featureData.number}</span>
                        )}
                    </div>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                    <Button size="small" type="primary" onClick={() => setEditModal(true)}>Edit</Button>
                    <Popconfirm
                        title="Delete Feature"
                        description="Are you sure?"
                        placement="topRight"
                        onConfirm={handleDelete}
                        okText="Delete"
                        cancelText="Cancel"
                        okButtonProps={{ danger: true }}
                    >
                        <Button size="small" danger>Delete</Button>
                    </Popconfirm>
                </div>
            </div>

            <Modal
                open={editModal}
                width={800}
                title="Edit Feature"
                footer={null}
                onCancel={() => setEditModal(false)}
            >
                <EditFeatureModal
                    featureId={feature.id}
                    onClose={() => { setTriggerReload(prev => prev + 1); setEditModal(false); }}
                />
            </Modal>
        </div>
    );
};

export default FeatureItems;
